import React, {Fragment, useState} from 'react';

import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import DropdownAlternateProvisionReason from "root/ReactHookForm/ui/DropdownAlternateProvisionReason";
import { FormInput, FormTextarea, FormInputDatePicker, FormInputCheckbox } from "root/ReactHookForm/FormComponents";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents/SmartErrorDiv";
import AltProvidersSection from "root/AltProviders/AltProvidersSection";
import {useChildContext} from "root/Contexts/ChildContext";

const HookSubFormFullTimeEducation = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const { child } = useChildContext() ;

    const alternate_provision_start_date = child.alternate_provision_start_date ;

    const [ showLegacy, setShowLegacy ] = useState ( !(alternate_provision_start_date === null || +child.hide_legacy_ap === 1) ) ;

    const isFullTimeEducation = watch(sectionName + '.full_time_education_flag')

    const validateAPReason = (val) =>
    {
        if (val === null)
        {
            return "Please Select a reason.";
        }
    }

    const hideLegacy = () =>
    {
        setShowLegacy( false ) ;
    }

    return (
        <FieldsetContainer title='Full Time Education' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Is the pupil attending full time school?' sectionName={sectionName} name={'full_time_education_flag'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            {isFullTimeEducation === false &&
                <Fragment>
                    <BootstrapRow>
                        <BootstrapCol width={12}>
                            <AltProvidersSection readOnly={readOnly} hasLegacy={showLegacy} hideLegacy={hideLegacy}/>
                        </BootstrapCol>
                    </BootstrapRow>

                    { showLegacy === true && <Fragment>
                    <BootstrapRow>
                        <BootstrapCol width={6}>
                            <FormInputDatePicker readOnly={readOnly} label='Alternate Provision Start Date' sectionName={sectionName}
                                                 name={'alternate_provision_start_date'}
                                                 control={control} required={true} formErrors={formErrors}/>
                        </BootstrapCol>
                        <BootstrapCol width={6}>
                            <FormInputDatePicker readOnly={readOnly} label='Alternate Provision Agreement Date' sectionName={sectionName}
                                                 name={'alternate_provision_agreement_date'}
                                                 control={control} required={true} formErrors={formErrors}/>
                        </BootstrapCol>
                    </BootstrapRow>

                    <BootstrapRow>
                        <BootstrapCol width={8}>
                            <label className='col-form-label'>Select the CME Reason</label>
                            <DropdownAlternateProvisionReason name={sectionName + '.ap_reason_id'} control={control} rules={{validate: validateAPReason}}
                                                              placeHolder='Pick a CME Reason' readOnly={readOnly}/>
                            <SmartErrorDiv sectionName={sectionName}  name={'ap_reason_id'} formErrors={formErrors} />
                        </BootstrapCol>
                        <BootstrapCol width={4}>
                            <FormInput readOnly={readOnly} label='Number of Hours' sectionName={sectionName} name={'alternate_provision_hours'} register={register} required={true}
                                       maxLength={100} formErrors={formErrors}/>
                        </BootstrapCol>

                    </BootstrapRow>

                    <BootstrapRow>
                        <BootstrapCol width={12}>
                            <FormTextarea readOnly={readOnly} label='Details / Reason' sectionName={sectionName} name={'alternate_provision_reason'} register={register}
                                          required={false}
                                          maxLength={200} formErrors={formErrors}/>
                        </BootstrapCol>
                    </BootstrapRow>

                    <BootstrapRow>
                        <BootstrapCol width={6}>
                            <FormTextarea readOnly={readOnly} label='Name of Alternate Provision' sectionName={sectionName} name={'alternate_provision'} register={register}
                                          required={false}
                                          maxLength={1000} formErrors={formErrors}/>
                        </BootstrapCol>
                        <BootstrapCol width={6}>
                            <FormTextarea readOnly={readOnly} label='Days, Times etc' sectionName={sectionName} name={'alternate_provision_notes'} register={register}
                                          required={false}
                                          maxLength={1000} formErrors={formErrors}/>
                        </BootstrapCol>
                    </BootstrapRow>
                    </Fragment> }
                </Fragment>
            }

        </FieldsetContainer>
    )
}


export default HookSubFormFullTimeEducation;
